import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	notConnectedText: {
		id: 'servicedesk-incident-management-settings.common.communication-card.not-connected-text',
		defaultMessage: 'Not Connected',
		description: 'When no microsoft teams connection exists',
	},
	microsoftTeamsLabel: {
		id: 'servicedesk-incident-management-settings.common.communication-card.microsoft-teams-label',
		defaultMessage: 'Microsoft Teams',
		description: 'Label to indicate the connection for Microsoft Teams',
	},
	noMsTeamAppConnected: {
		id: 'servicedesk-incident-management-settings.common.communication-card.no-ms-team-app-connected',
		defaultMessage: 'You need to connect a Microsoft tenant to your Jira Service Management site.',
		description: 'Tooltip content for App Install',
	},
	noZoomAppConnected: {
		id: 'servicedesk-incident-management-settings.common.communication-card.no-zoom-app-connected',
		defaultMessage: 'You need to connect a Zoom account to your Jira Service Management site.',
		description: 'Tooltip content for App Install',
	},
	connectTeamApp: {
		id: 'servicedesk-incident-management-settings.common.communication-card.connect-team-app',
		defaultMessage: 'Connect Microsoft Teams',
		description: 'Button for Redirecting to admin page',
	},
	connectZoomApp: {
		id: 'servicedesk-incident-management-settings.common.communication-card.connect-zoom-app',
		defaultMessage: 'Connect Zoom account',
		description: 'Button for Redirecting to admin page',
	},
	enabledDisabledAriaLabel: {
		id: 'servicedesk-incident-management-settings.common.communication-card.enabled-disabled-aria-label',
		defaultMessage: 'On/Off',
		description: 'Aria Label for Toggle used to enable/disabled MS Teams settings',
	},
	contactJiraAdmin: {
		id: 'servicedesk-incident-management-settings.common.communication-card.contact-jira-admin',
		defaultMessage: 'Contact Jira admin ',
		description: 'Button Label for reaching out to Jira Admin',
	},
	contactAdminToolTip: {
		id: 'servicedesk-incident-management-settings.common.communication-card.contact-admin-tool-tip',
		defaultMessage:
			'Contact your Jira site admin to connect Microsoft Teams, so agents can create chats and meetings.',
		description: 'ToolTip Content for reaching out to Jira Admin regarding Teams app',
	},
	contactAdminZoomToolTip: {
		id: 'servicedesk-incident-management-settings.common.communication-card.contact-admin-zoom-tool-tip',
		defaultMessage:
			'Contact your Jira site admin to connect Zoom account, so agents can create meetings.',
		description: 'ToolTip Content for reaching out to Jira Admin regarding Zoom App',
	},
	enabledSetting: {
		id: 'servicedesk-incident-management-settings.common.communication-card.enabled-setting',
		defaultMessage: 'Enabled',
		description: 'ToolTip Content for reaching out to Jira Admin regarding Zoom App',
	},
	disabledSetting: {
		id: 'servicedesk-incident-management-settings.common.communication-card.disabled-setting',
		defaultMessage: 'Disabled',
		description: 'ToolTip Content for reaching out to Jira Admin regarding Zoom App',
	},
});
